import { COLORS } from '@constants';
import styled from 'styled-components';

export const StyledAlert = styled.div`
    padding: 23px 24px;
    border: 1px solid ${({ $isValid }) => ($isValid ? COLORS.$robinBlue : COLORS.$tartRed)};
    border-radius: 8px;
    background: ${({ $isValid }) => ($isValid ? COLORS.$robinTintsBlue : COLORS.$tartRedLite)};
`;
